"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.getDamageReason = exports.EVoyageCrewDamageType = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var EVoyageCrewDamageType;
(function (EVoyageCrewDamageType) {
    EVoyageCrewDamageType[EVoyageCrewDamageType["Null"] = 0] = "Null";
    EVoyageCrewDamageType[EVoyageCrewDamageType["Heal"] = 1] = "Heal";
    EVoyageCrewDamageType[EVoyageCrewDamageType["SmallBullet"] = 2] = "SmallBullet";
    EVoyageCrewDamageType[EVoyageCrewDamageType["Fire"] = 3] = "Fire";
    EVoyageCrewDamageType[EVoyageCrewDamageType["NoOxygen"] = 4] = "NoOxygen";
    EVoyageCrewDamageType[EVoyageCrewDamageType["FoundLikeThat"] = 5] = "FoundLikeThat";
    EVoyageCrewDamageType[EVoyageCrewDamageType["FireExtinguisher"] = 6] = "FireExtinguisher";
    EVoyageCrewDamageType[EVoyageCrewDamageType["Repair"] = 7] = "Repair";
    EVoyageCrewDamageType[EVoyageCrewDamageType["Suicide"] = 8] = "Suicide";
    EVoyageCrewDamageType[EVoyageCrewDamageType["Jettison"] = 9] = "Jettison";
    EVoyageCrewDamageType[EVoyageCrewDamageType["Teleport"] = 10] = "Teleport";
    EVoyageCrewDamageType[EVoyageCrewDamageType["Slash"] = 11] = "Slash";
    EVoyageCrewDamageType[EVoyageCrewDamageType["Pierce"] = 12] = "Pierce";
    EVoyageCrewDamageType[EVoyageCrewDamageType["Magic"] = 13] = "Magic";
    // TODO: refactor damage types
    // Lightning = 14
})(EVoyageCrewDamageType = exports.EVoyageCrewDamageType || (exports.EVoyageCrewDamageType = {}));
function getDamageReason(t) {
    switch (t) {
        case EVoyageCrewDamageType.Null:
            return 'Null';
        case EVoyageCrewDamageType.Heal:
            return 'Healed';
        case EVoyageCrewDamageType.SmallBullet:
            return 'Gunfire wounds';
        case EVoyageCrewDamageType.Fire:
            return 'Combusted';
        case EVoyageCrewDamageType.NoOxygen:
            return 'Asphyxiated';
        case EVoyageCrewDamageType.FoundLikeThat:
            return 'We did not do it';
        case EVoyageCrewDamageType.FireExtinguisher:
            return 'Fire extinguished';
        case EVoyageCrewDamageType.Repair:
            return 'Repaired';
        case EVoyageCrewDamageType.Suicide:
            return 'Suicide';
        case EVoyageCrewDamageType.Jettison:
            return 'Jettison';
        case EVoyageCrewDamageType.Teleport:
            return 'Teleported';
        case EVoyageCrewDamageType.Slash:
            return 'Slash';
        case EVoyageCrewDamageType.Pierce:
            return 'Pierce';
        case EVoyageCrewDamageType.Magic:
            return 'Magic';
        default:
            return 'Unknown';
    }
}
exports.getDamageReason = getDamageReason;
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.CrewHurt;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.byCrewId);
    messageWriter_sidecar_1.messageWriter.write16(m, d.newHitpoints);
    messageWriter_sidecar_1.messageWriter.write8(m, d.type);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
        byCrewId: messageWriter_sidecar_1.messageWriter.read32(m),
        newHitpoints: messageWriter_sidecar_1.messageWriter.read16(m),
        type: messageWriter_sidecar_1.messageWriter.read8(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        crewId: 100,
        byCrewId: 123,
        newHitpoints: 55,
        type: EVoyageCrewDamageType.NoOxygen,
    };
    messageWriter_sidecar_1.messageWriter.test('crew-hurt', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    diveCrew_sidecar_1.diveCrew.networkHurt(msg);
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
